(function(){
  'use strict';
  function initFloatingVideo(root){
    var container = root;
    if(!container) return;
    var sectionId = container.getAttribute('data-section-id') || '';
    var scrim = document.querySelector('.featured-video__scrim[data-section-id="'+sectionId+'"]');
    var closeBtn = container.querySelector('.featured-video__close');
    var videoEl = container.querySelector('video');

    var clickThreshold=6;
    var swipeStartY = 0;
    var swipeStartX = 0;
    var isSwiping = false;
    var initialTransform = '';
    var gestureActive = false;
    
    function enterFullscreen(){
      if(container.classList.contains('is-fullscreen')) return;
      container.style.transform = '';
      container.classList.add('is-fullscreen');
      if(scrim) scrim.classList.add('is-visible');
      if(videoEl){
        try { videoEl.muted = false; } catch(_){ }
        if (videoEl.play) { videoEl.play().catch(function(){}); }
      }
      try { document.body.classList.add('overlay-open'); } catch(_) {}
      gestureActive = false;
    }
    function exitFullscreen(){
      if(!container.classList.contains('is-fullscreen')) return;
      container.classList.remove('is-fullscreen');
      container.style.transform = '';
      container.style.opacity = '';
      if(scrim) scrim.classList.remove('is-visible');
      if(scrim) scrim.style.opacity = '';
      if(videoEl){
        try { videoEl.muted = true; } catch(_){ }
      }
      try { document.body.classList.remove('overlay-open'); } catch(_) {}
    }
    function hideContainer(){
      // Ensure fullscreen state is cleared so overlay detection can restore header
      exitFullscreen();
      container.setAttribute('data-state','hidden');
      if(scrim) scrim.classList.remove('is-visible');
      if(scrim) scrim.style.opacity = '';
      try { document.body.classList.remove('overlay-open'); } catch(_) {}
    }

    if(closeBtn) closeBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); hideContainer(); });
    if(scrim) scrim.addEventListener('click', exitFullscreen);
    container.addEventListener('click', function(e){
      if(e.target && e.target.closest && e.target.closest('.featured-video__close')) return;
      if(!container.classList.contains('is-fullscreen')) enterFullscreen();
    });

    // Swipe down gesture to exit fullscreen
    function handleSwipeStart(e) {
      if(!container.classList.contains('is-fullscreen')) { gestureActive = false; return; }
      var touch = e.touches ? e.touches[0] : e;
      swipeStartY = touch.clientY;
      swipeStartX = touch.clientX;
      isSwiping = false;
      initialTransform = container.style.transform || '';
      gestureActive = true;
    }
    
    function handleSwipeMove(e) {
      if(!container.classList.contains('is-fullscreen') || !gestureActive) return;
      var touch = e.touches ? e.touches[0] : e;
      var deltaY = touch.clientY - swipeStartY;
      var deltaX = Math.abs(touch.clientX - swipeStartX);
      
      // Only track vertical swipes (deltaY > deltaX)
      if(Math.abs(deltaY) > 10 && Math.abs(deltaY) > deltaX) {
        isSwiping = true;
        
        // Only allow downward swipes
        if(deltaY > 0) {
          e.preventDefault();
          var opacity = Math.max(0, 1 - (deltaY / 300));
          container.style.transform = 'translateY(' + deltaY + 'px)';
          container.style.opacity = opacity;
          if(scrim) scrim.style.opacity = opacity;
        }
      }
    }
    
    function handleSwipeEnd(e) {
      if(!container.classList.contains('is-fullscreen') || !gestureActive) return;
      var touch = e.changedTouches ? e.changedTouches[0] : e;
      var deltaY = touch.clientY - swipeStartY;
      
      // If swiped down more than 100px, exit fullscreen
      if(isSwiping && deltaY > 100) {
        exitFullscreen();
      } else {
        // Reset position
        container.style.transform = initialTransform;
        container.style.opacity = '';
        if(scrim) scrim.style.opacity = '';
      }
      
      isSwiping = false;
      gestureActive = false;
    }
    
    container.addEventListener('touchstart', handleSwipeStart, { passive: true });
    container.addEventListener('touchmove', handleSwipeMove, { passive: false });
    container.addEventListener('touchend', handleSwipeEnd, { passive: true });
    container.addEventListener('mousedown', handleSwipeStart);
    container.addEventListener('mousemove', handleSwipeMove);
    container.addEventListener('mouseup', handleSwipeEnd);

    // Intentionally no resize reflow: we keep current transform to avoid jank.

    function hasVideoSource(v){
      if(!v) return false;
      if(v.currentSrc && v.currentSrc.length) return true;
      if(v.src && v.src.length) return true;
      var s = v.querySelectorAll('source');
      for(var i=0;i<s.length;i++){ if(s[i].src && s[i].src.length) return true; }
      return false;
    }
    function markNotEmpty(){ try { container.setAttribute('data-empty','false'); } catch(_){} }

    if(videoEl){
      // If a real video source already exists, hide placeholder immediately
      if(hasVideoSource(videoEl)) { markNotEmpty(); }

      var prime = function(){
        var source = videoEl.querySelector('source[data-src]');
        if(source && !source.src){ source.src = source.getAttribute('data-src'); videoEl.load(); }
        videoEl.play && videoEl.play().catch(function(){});
        markNotEmpty();
      };
      // Hide placeholder once video is ready/playing
      videoEl.addEventListener('loadeddata', markNotEmpty);
      videoEl.addEventListener('playing', markNotEmpty);
      if(window.requestIdleCallback){ requestIdleCallback(prime, { timeout: 1500 }); } else { setTimeout(prime, 800); }
    }
  }

  function initAll(){
    document.querySelectorAll('.featured-video__container').forEach(initFloatingVideo);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
